<template>
  <div class="et-color">
    <div type="color" class="et-color-show" :style="{ backgroundColor: data.color }" @click="openColorPicker"></div>
    <input class="et-color-input" type="text" v-model="data.color">
  </div>

  <teleport to="body">
    <div v-if="data.visible" class="et-color-picker" :style="{
      transform: `translate(${data.x}px, ${data.y}px)`,
    }">
      <div class="et-color-box" :style="{ backgroundColor: previewColor }" ref="colorBoxRef" @mousedown="onMouseDown">
        <div class="et-color-point" :style="{ transform: `translate(${pointLeft}px, ${pointTop}px)` }"></div>
      </div>

      <div class="et-color-slider opacity" :style="opacityColor" ref="sliderRef1" @mousedown="onMouseDown1">
        <div class="et-color-slider-bar" :style="{ transform: `translate(${sliderBarLeft1}px, -50%)` }"></div>
      </div>
      <div class="et-color-slider color" ref="sliderRef2" @mousedown="onMouseDown2">
        <div class="et-color-slider-bar" :style="{ transform: `translate(${sliderBarLeft2}px, -50%)` }"></div>
      </div>
    </div>
  </teleport>

</template>

<script setup>
import { ref, reactive, computed, onMounted, onUnmounted, watch } from 'vue'
import { clamp, hsvToRgb } from '@/topo/core/utils'
// import {color} from 'echarts'

const props = defineProps({
  modelValue: {
    type: String,
    default: '#f00',
  },
})


const emit = defineEmits(['update:modelValue', 'change'])

// 初始化色调、饱和度、亮度和透明度
const hue = ref(0)
const saturation = ref(1)
const value = ref(1)
const alpha = ref(1)


const data = reactive({
  color: props.modelValue,
  visible: false,

  x: 0,
  y: 0,
})

watch(() => props.modelValue, (newVal) => {
  data.color = newVal
})

const resultColor = computed(() => {
  const rgb = hsvToRgb(hue.value, saturation.value, value.value)
  return {
    ...rgb,
    a: alpha.value,
  }
})

watch(() => resultColor.value, (newVal) => {
  const colorStr = `rgba(${newVal.r}, ${newVal.g}, ${newVal.b}, ${newVal.a})`
  emit('update:modelValue', colorStr)
  emit('change', colorStr)
})


function openColorPicker(event) {
  data.visible = true

  // 180 是选择器的宽度
  // 220 是选择器的高度
  data.x = Math.min(event.clientX + 15, window.innerWidth - 160)
  data.y = Math.min(event.clientY + 15, window.innerHeight - 220)
}


function onDocumentClick(event) {
  console.log('doc click');

  if (!data.visible) return
  if (
    event.target.closest('.et-color-picker')
    || event.target.className == "et-color-show"
    || isMouseDown1.value
    || isMouseDown2.value) return
  data.visible = false
}


onMounted(() => {
  window.addEventListener('mousedown', onDocumentClick)
})

onUnmounted(() => {
  window.removeEventListener('mousedown', onDocumentClick)
})




const previewColor = computed(() => {
  const rgb = hsvToRgb(hue.value, 1, 1)
  return `rgba(${rgb.r}, ${rgb.g}, ${rgb.b}, 1)`
})

const opacityColor = computed(() => {
  const rgb = hsvToRgb(hue.value, saturation.value, value.value)
  return {
    '--start-color': `rgba(${rgb.r}, ${rgb.g}, ${rgb.b}, 0)`,
    '--end-color': `rgba(${rgb.r}, ${rgb.g}, ${rgb.b}, 1)`
  }
})


function useSilder(options) {
  const sliderRef = ref(null)
  const sliderBarLeft = ref(0)
  const percentage = ref(0)
  const isMouseDown = ref(false)

  const defaultOpt = {
    // 滑块移动时的回调函数
    onSlide: () => { }
  }
  Object.assign(defaultOpt, options)


  const updateBarPosition = (event) => {
    let sliderBarWidth = 4
    let sliderSize = sliderRef.value.getBoundingClientRect()
    let x = event.pageX - sliderSize.left
    let left = sliderSize.width - sliderBarWidth
    // 防止出现0导致结果为NaN
    left = (left === 0) ? 0.000001 : left

    // 限制滑块的移动范围
    sliderBarLeft.value = clamp(0, left, x)

    // 计算百分比
    percentage.value = sliderBarLeft.value / left

    defaultOpt.onSlide(percentage.value)
  }

  const onMouseDown = (event) => {
    event.stopPropagation()
    isMouseDown.value = true
    updateBarPosition(event)
  }

  const onMouseUp = () => {
    console.log('mouse up');
    isMouseDown.value = false
  }

  const onMouseMove = (event) => {
    event.stopPropagation()
    if (!isMouseDown.value) return
    updateBarPosition(event)
  }



  onMounted(() => {
    window.addEventListener('mousemove', onMouseMove)
    window.addEventListener('mouseup', onMouseUp)
  })

  onUnmounted(() => {
    window.removeEventListener('mousemove', onMouseMove)
    window.removeEventListener('mouseup', onMouseUp)
  })


  return {
    isMouseDown,
    sliderRef,
    sliderBarLeft,
    percentage,
    onMouseDown,
  }

}

const {
  isMouseDown: isMouseDown1,
  sliderRef: sliderRef1,
  sliderBarLeft: sliderBarLeft1,
  onMouseDown: onMouseDown1,
} = useSilder({
  onSlide(percentage) {
    alpha.value = percentage

    const rgb = hsvToRgb(hue.value, saturation.value, value.value)
    const rgba = `rgba(${rgb.r}, ${rgb.g}, ${rgb.b}, ${alpha.value})`
    data.color = rgba
  }
})


const {
  isMouseDown: isMouseDown2,
  sliderRef: sliderRef2,
  sliderBarLeft: sliderBarLeft2,
  onMouseDown: onMouseDown2,
} = useSilder({
  onSlide(percentage) {

    hue.value = percentage * 360

    const rgb = hsvToRgb(hue.value, saturation.value, value.value)
    const rgba = `rgba(${rgb.r}, ${rgb.g}, ${rgb.b}, ${alpha.value})`
    data.color = rgba
   }

})


function usePoint(options) {
  const colorBoxRef = ref(null)
  const pointLeft = ref(0)
  const pointTop = ref(0)
  const defaultOpt = {
    // 滑块移动时的回调函数
    onMove: () => { }
  }
  Object.assign(defaultOpt, options)
  const updatePointPosition = (event) => {

    let colorBoxSize = colorBoxRef.value.getBoundingClientRect()
    let x = event.pageX - colorBoxSize.left
    let y = event.pageY - colorBoxSize.top
    // 限制滑块的移动范围
    pointLeft.value = clamp(0, colorBoxSize.width - 10, x)
    pointTop.value = clamp(0, colorBoxSize.height - 10, y)
    console.log('point move', pointLeft.value, pointTop.value);
    defaultOpt.onMove(pointLeft.value, pointTop.value)
  }
  const onMouseDown = (event) => {
    event.stopPropagation()
    updatePointPosition(event)


    window.addEventListener('mousemove', onMouseMove)
    window.addEventListener('mouseup', onMouseUp)
  }
  const onMouseMove = (event) => {
    // event.stopPropagation()
    updatePointPosition(event)
  }
  const onMouseUp = () => {
    window.removeEventListener('mousemove', onMouseMove)
    window.removeEventListener('mouseup', onMouseUp)
  }
  onMounted(() => {

  })


  return {
    colorBoxRef,
    pointLeft,
    pointTop,
    onMouseDown
  }
}


const {
  colorBoxRef,
  pointLeft,
  pointTop,
  onMouseDown
} = usePoint({
  onMove(x, y) {
    const colorBoxSize = colorBoxRef.value.getBoundingClientRect()
    const xPercentage = (x / (colorBoxSize.width - 10))
    const yPercentage = (y / (colorBoxSize.height - 10))

    // 更新颜色值
    saturation.value = xPercentage
    value.value = 1 - yPercentage

    const rgb = hsvToRgb(hue.value, saturation.value, value.value)
    const rgba = `rgba(${rgb.r}, ${rgb.g}, ${rgb.b}, ${alpha.value})`
    data.color = rgba
  }
})


</script>



<style scoped>
.et-color {
  display: flex;
  align-items: center;
  border: 1px solid var(--et-border);
  padding: 0 8px;
}
.et-color:focus-within {
  border: 1px solid #178ffc;
}

.et-color-show {
  min-width: 14px;
  min-height: 14px;
  border: 1px solid rgba(255, 255, 255, 0.5);
  box-shadow: 1px 1px 3px rgba(0, 0, 0, 0.5);
}

.et-color-picker {
  position: fixed;
  width: 160px;
  background: #000;
  top: 0;
  left: 0;
  z-index: 888;
  box-shadow: 1px 1px 10px rgba(0, 0, 0, 0.2);
  border-radius: 3px;
  user-select: none;
}

.et-color-box {
  width: 160px;
  height: 160px;
  border-bottom: 1px solid #fff;
  position: relative;
}

.et-color-point {
  position: absolute;
  width: 10px;
  height: 10px;
  /* background: #fff; */
  top: 0;
  left: 0;
  border: 1px solid #fff;
  box-shadow: 0px 0px 3px rgba(0, 0, 0, 1);
  border-radius: 50%;
  z-index: 2;
}

.et-color-box::before,
.et-color-box::after {
  content: '';
  position: absolute;
  inset: 0;
  z-index: 1;
}

.et-color-box::before {
  background: linear-gradient(to right, rgb(255, 255, 255), rgba(255, 255, 255, 0));
}

.et-color-box::after {
  background: linear-gradient(to top, rgb(0, 0, 0), rgba(0, 0, 0, 0));
}

.et-color-slider {
  background: #181c40;
  height: 16px;
  margin: 4px;
  position: relative;
  user-select: none;
}

.et-color-slider.color {
  background: linear-gradient(to right, red, #ff0 17%, #0f0 33%, #0ff, #00f 67%, #f0f 83%, red);
}

.et-color-slider.opacity {
  --start-color: rgba(0, 0, 0, 1);
  --end-color: rgba(0, 0, 0, 0);

  --alpha-bg-size: 5px;
  background-color: #fff;
  background-image: linear-gradient(45deg, lightgray 25%, transparent 25%, transparent 75%, lightgray 75%),
    linear-gradient(45deg, lightgray 25%, transparent 25%, transparent 75%, lightgray 75%);
  background-position: 0 0, calc(var(--alpha-bg-size) / 2) calc(var(--alpha-bg-size) / 2);
  background-size: var(--alpha-bg-size) var(--alpha-bg-size);
}

.et-color-slider.opacity::after {
  content: '';
  position: absolute;
  inset: 0;
  background: linear-gradient(to right, var(--start-color), var(--end-color));
}

.et-color-slider-bar {
  width: 4px;
  height: 20px;
  position: absolute;
  top: 50%;
  left: 0;
  transform: translateY(-50%);
  border: 1px solid #ffffff;
  box-shadow: 0px 0px 3px rgba(0, 0, 0, 0.6);
  z-index: 2;
}
</style>
